import React from 'react';

const appHeader = {
    height: '6em',
    position: 'absolute',
    zIndex: 9,
    width: '100%',
    backgroundColor: '#d4002a',
    color: 'white',
    boxShadow: '0em 0.2em 2em #888888'
};

const appLogo = {
    maxHeight: '90%',
    width: 'auto'
};
const ST_img = {
    float: 'none',
    textAlign: 'center',
    height: '4em',
    padding: '1.4em 0px',
    width: '11.6em',
    marginLeft: 'auto',
    marginRight: 'auto',
    verticalAlign: 'middle',
    display: 'block !important'
};
//<img src="https://avisassets.abgemea.com/resources/templating-kit/themes/avis-digital/img/avis-white-logo.png" alt="Avis car hire" width="115" height="32">

const HeaderSolid = () => (
    <div style={appHeader}>
        <div style={ST_img}>
            <span role="img"  style={{height: '4em'}}>
                <svg x="0px" y="0px" viewBox="480.014 487.143 86 24.152" enableBackground="new 480.014 487.143 86 24.152">
                    <desc itemProp="name">Home</desc>
                    <g>
                        <path fill="#fff" d="M549.539,493.461c-1.461-1.31-2.797-1.742-4.225-1.742s-3.215,0.489-3.215,2.307c0,1.523,1.365,2.04,3.541,2.725
                        c3.116,1.007,7.141,2.307,7.141,6.884c0,5.29-4.252,7.66-8.797,7.66c-3.279,0-6.592-1.2-8.603-3.312l3.403-3.492
                        c1.356,1.459,3.381,2.227,5.199,2.227c1.688,0,3.182-0.651,3.182-2.5c0-1.753-1.755-2.34-4.773-3.317
                        c-2.919-0.94-5.873-2.398-5.873-6.55c0-5.098,4.608-7.207,8.892-7.207c2.599,0,5.521,0.975,7.532,2.822L549.539,493.461z
                        M495.21,501.752h-5.776l2.919-7.89L495.21,501.752z M504.688,510.71l-9.4-22.985h-5.529l-9.744,22.985h6.141l1.686-4.512h8.899
                        l1.785,4.512H504.688z M524.41,487.725h-6.134l-5.323,16.61l-5.42-16.61h-6.232L510,510.71h5.551L524.41,487.725z M526.635,510.71
                        h5.583v-22.985h-5.583V510.71z">
                        </path>
                    </g>
                    <g>
                        <path fill="#fff" d="M561.791,487.237c-2.314,0-4.195,1.859-4.195,4.186c0,2.328,1.881,4.15,4.195,4.15c2.34,0,4.223-1.822,4.223-4.15
                        C566.014,489.096,564.131,487.237,561.791,487.237z M561.791,494.969c-1.945,0-3.529-1.609-3.529-3.546
                        c0-1.959,1.584-3.543,3.529-3.543c1.967,0,3.56,1.584,3.56,3.543C565.351,493.36,563.758,494.969,561.791,494.969z"></path>
                        <path fill="#fff" d="M562.484,491.7c0.668-0.147,1.092-0.592,1.092-1.275c0-1.014-0.872-1.384-1.776-1.384h-1.638v4.728h0.851v-1.974h0.621
                        l1.093,1.974h1.031L562.484,491.7z M561.013,491.108v-1.346h0.769c0.445,0,0.945,0.127,0.945,0.644
                        c0,0.572-0.553,0.702-1.051,0.702H561.013z">
                        </path>
                    </g>
                </svg>
            </span>
        </div>
    </div>
);

export default HeaderSolid;



// WEBPACK FOOTER //
// ./src/components/UI/Header.jsx